import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {hAreaCodeEnum} from 'hiya-common/src/reducers/env'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const female_rec_card_reward_config = createAsyncThunk(
  // [欢迎页奖励列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=167792999
  'Saada/FemaleUser/live/hiya_socialize/female_rec_card_reward_config',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/female_rec_card_reward_config',
      arg,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const use_female_rec_card = createAsyncThunk(
  // [使用女性推荐卡] http://wiki.xunlei.cn/pages/viewpage.action?pageId=167793008
  'Saada/FemaleUser/live/hiya_socialize/use_female_rec_card',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/use_female_rec_card',
      arg,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const face_verify_homepage = createAsyncThunk(
  // [真人认证主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=148323548
  'Saada/FemaleUser/live/hiya_socialize/face_verify_homepage',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/face_verify_homepage',
      arg,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const switch_auto_use_female_rec_card = createAsyncThunk(
  // [自动匹配开关] http://wiki.xunlei.cn/pages/viewpage.action?pageId=167793011
  'Saada/FemaleUser/live/hiya_socialize/switch_auto_use_female_rec_card',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/switch_auto_use_female_rec_card',
      arg,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_female_rec_card_reward_coin = createAsyncThunk(
  // [获取女性推荐卡奖励金币] http://wiki.xunlei.cn/pages/viewpage.action?pageId=167793017
  'Saada/FemaleUser/live/hiya_socialize/get_female_rec_card_reward_coin',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_female_rec_card_reward_coin',
      arg,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const female_rec_card_home_page = createAsyncThunk(
  // [女性推荐卡主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=167793019
  'Saada/FemaleUser/live/hiya_socialize/female_rec_card_home_page',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/female_rec_card_home_page',
      arg,
      {store}
    )
    return resp.data.data
  }
)

export const fetch_new_female_task_page = createAsyncThunk(
  // [新女任务数据] http://wiki.xunlei.cn/pages/viewpage.action?pageId=179483508
  'Saada/FemaleUser/live/hiya_socialize/fetch_new_female_task_page',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/fetch_new_female_task_page',
      arg,
      {store}
    )
    return resp.data.data
  }
)
export const acquire_new_female_task_reward = createAsyncThunk(
  // [领取任务奖励（特制任务页下方的任务）] http://wiki.xunlei.cn/pages/viewpage.action?pageId=179483508
  'Saada/FemaleUser/live/hiya_socialize/acquire_new_female_task_reward',
  async (arg: any, store: any) => {
    const resp = await http.post(
      'live/hiya_socialize/acquire_new_female_task_reward',
      arg,
      {store}
    )
    return resp.data.data
  }
)

/** 获得N珍珠提现 */
export interface PearlExchangeInfo {
  pearl_amount: number
  currency_amount: number
  currency_code: string
  status: 0 | 1 | 2 // 0-未达提现门槛，1-已达提现门槛，2-已提现
  jump_url?: string // status=0 时不返回
  display_content: string
  currency_icon: string
}

/** 真人认证信息，当 real_auth=false 时返回 */
export interface RealAuthInfo {
  display_content: string
  jump_url: string
}

/** 推荐卡 */
export interface RecCardInfo {
  display_content: string
  real_auth: boolean
  real_auth_info?: RealAuthInfo // 当 real_auth=false 时返回
  status: 1 | 2 | 3 // 1:未使用, 2:推荐中, 3:用完了
  used_rec_card_num: number
  total_rec_card_num: number
  count_down_sec: number
}

/** 任务列表项 */
export interface TaskItem {
  task_id: number
  task_name: string
  task_icon: string
  jump_url: string
  reward_type: 1 | 2 // 1-珍珠，2-保量卡
  task_status: 0 | 1 | 2 // 0-未完成，1-已完成待领取，2-已领取
  task_type: 1 | 2 // 1-每日任务，2-一次性任务
  reward_cnt: number
  subtask_need_cnt: number
  subtask_cur_cnt: number
  reward_icon: string
}

export enum EnumMatchingStatus {
  Init = 1, // 初始状态
  CoolDown = 2, // 冷却中
  Recommend = 3, // 推荐中
  Out = 4, // 用完了
  ShowResult = 5, // 展示结果
}

export interface InitialStateType {
  home?: {
    config: {coin_cnt: number; card_cnt: number}[]
    today: number // 今天是第几天
    status: EnumMatchingStatus // 1:初始状态, 2:冷却中, 3:推荐中 4:用完了 5:展示结果
    coin_status: 0 | 1 // 今天金币领没领, 0没领 1领了
    auto_use_status: 0 | 1 // 自动匹配开关, 0关闭 1开启
    count_down: number // 冷却时间
    card_cnt: number // 剩余卡数
    total_reply: number // reply 人数
    reply_list: {mid: number; name: string; avatar: string}[]
  }
  welcome?: {
    list: {coin_cnt: number; card_cnt: number}[]
    pearl_amount: number // 珍珠数，固定10000
    currency_amount: number // 当地货币量
    currency_code: string // 币种，"USD"
    currency_icon: string // 币种图标链接
  }
  verify?: {
    avatar: string
    real_auth_status: 0 | 1 | 2 | 3 // 0 未认证，1 认证成功，2认证失败  3 认证疑似
  }

  taskHome?: {
    earned_pearl_num: number
    pearl_exchange_info: PearlExchangeInfo
    rec_card_info: RecCardInfo
    task_list: TaskItem[]
  }
}

const initialState: InitialStateType = {}

export const SaadaFemaleUserWelcomeSlice = createSlice({
  name: 'Animal_Doe',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      female_rec_card_reward_config.fulfilled,
      (state, action) => {
        Object.assign(state, {welcome: action.payload})
      }
    )
    builder.addCase(face_verify_homepage.fulfilled, (state, action) => {
      Object.assign(state, {verify: action.payload})
    })
    builder.addCase(female_rec_card_home_page.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload})
    })
    builder.addCase(fetch_new_female_task_page.fulfilled, (state, action) => {
      Object.assign(state, {taskHome: action.payload})
    })
  },
})
export default SaadaFemaleUserWelcomeSlice.reducer
export const SaadaFemaleUserWelcomeActions = SaadaFemaleUserWelcomeSlice.actions

export const useSaadaFemaleUserWelcomeState = () => {
  const data = useSelector((state) => {
    return state.Animal_Doe
  })
  return data
}
